/* eslint-disable */
import { countriesPhoneCode, defaultCountryCode } from "@constants";
import classNames from "classnames";
import { t } from "i18next";
import { CountryCode } from "libphonenumber-js";
import { useSnapshot } from "valtio";

import React from "react";
import { FaMobileAlt } from "react-icons/fa";

import { capitalize } from "@helpers/general";

import { kioskStore } from "@pages/Kiosk/store";

import "./index.css";

type FormInputsPropsType = {
    name: string;
    type: string;
    setInputName: React.Dispatch<React.SetStateAction<string>>;
    formik: any;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputRef: React.RefObject<HTMLInputElement>;
};

export function FormInputs({
    name,
    type,
    setInputName,
    formik,
    onChange,
    inputRef,
}: FormInputsPropsType): JSX.Element {
    return (
        <div className="d-flex flex-column" style={{ width: "100%" }}>
            <FormInputLabel name={name} />
            <FormInputItem
                name={name}
                formik={formik}
                setInputName={setInputName}
                type={type}
                onChange={onChange}
                inputRef={inputRef}
            />
            <FormInputErrorMessage formik={formik} name={name} />
        </div>
    );
}

type formInputLabelType = {
    name: string;
};
function FormInputLabel({ name }: formInputLabelType) {
    return (
        <label
            htmlFor={name}
            style={{ fontSize: "30px" }}
            className={classNames("label-form-created-account_clz", {
                required__clz: name === "phoneNumber" || name === "firstName",
            })}
        >
            {capitalize(t(name))}
        </label>
    );
}

type formInputItemType = {
    name: string;
    formik: any;
    setInputName: React.Dispatch<React.SetStateAction<string>>;
    type: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputRef: React.RefObject<HTMLInputElement>;
};
function FormInputItem({
    name,
    formik,
    setInputName,
    onChange,
    inputRef,
}: formInputItemType) {
    const { customerLanguage } = useSnapshot(kioskStore);
    const countryCode = customerLanguage.name.toUpperCase() as CountryCode;
    const countryInfo = countriesPhoneCode[countryCode] || defaultCountryCode;
    return (
        <React.Fragment>
            {name === "phoneNumber" ? (
                <>
                    <div className="input-container" style={{ width: "58rem" }}>
                        <FaMobileAlt />
                        <input
                            ref={inputRef}
                            id={name}
                            name={name}
                            type="tel"
                            value={formik.values[name]}
                            onChange={onChange}
                            onFocus={() => {
                                setInputName(name);
                            }}
                            maxLength={countryInfo.length}
                            minLength={countryInfo.length}
                            pattern={countryInfo.pattern}
                            placeholder={countryInfo.placeholder}
                        />
                    </div>
                </>
            ) : (
                <input
                    ref={inputRef}
                    id={name}
                    name={name}
                    className="input-container"
                    style={{ width: name === "email" ? "58rem" : "27.5rem" }}
                    value={formik.values[name]}
                    onFocus={() => {
                        setInputName(name);
                    }}
                    onChange={onChange}
                />
            )}
        </React.Fragment>
    );
}

type formInputErrorMessageType = {
    formik: any;
    name: string;
};
function FormInputErrorMessage({ formik, name }: formInputErrorMessageType) {
    return (
        <React.Fragment>
            {formik.touched[name] && formik.errors[name] ? (
                <div style={{ color: "red" }}>{formik.errors[name]}</div>
            ) : null}
        </React.Fragment>
    );
}
